import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { Repository } from "./Repository";
import { LocalStorageItems } from "./types";
export var LocalRepository =
/*#__PURE__*/
function (_Repository) {
  _inherits(LocalRepository, _Repository);

  function LocalRepository() {
    _classCallCheck(this, LocalRepository);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalRepository).apply(this, arguments));
  }

  _createClass(LocalRepository, [{
    key: "getCheckout",
    value: function getCheckout() {
      return this.retrieveObject(LocalStorageItems.CHECKOUT);
    }
  }, {
    key: "setCheckout",
    value: function setCheckout(checkout) {
      this.saveObject(LocalStorageItems.CHECKOUT, checkout);
    }
  }, {
    key: "getPayment",
    value: function getPayment() {
      return this.retrieveObject(LocalStorageItems.PAYMENT);
    }
  }, {
    key: "setPayment",
    value: function setPayment(payment) {
      this.saveObject(LocalStorageItems.PAYMENT, payment);
    }
  }, {
    key: "getJobs",
    value: function getJobs() {
      return this.retrieveObject(LocalStorageItems.JOB_QUEUE_CHECKOUT);
    }
  }, {
    key: "setJobs",
    value: function setJobs(jobs) {
      return this.saveObject(LocalStorageItems.JOB_QUEUE_CHECKOUT, jobs);
    }
  }]);

  return LocalRepository;
}(Repository);